module.exports = __webpack_public_path__ + "static/media/login-logo.e2aaee1e.svg";